export const sessionStorageKeyConstants = {
    SUBMITTED_STATE: "submittedState",
    /** Counts SuppressConceptFunnel → heritage redirects to avoid an infinite loop in one tab session. */
    HERITAGE_SUPPRESS_REDIRECT_COUNT: "heritageSuppressRedirectCount",
    /** Counts beforeEach uncaught-exception recovery attempts to avoid an infinite ERROR redirect loop. */
    BEFORE_EACH_ERROR_RECOVERY_COUNT: "beforeEachErrorRecoveryCount",
    /** Persists deep-link / querystring funnel entry state across navigations. */
    EXTERNAL_PARAMETER_STATE: "externalParameterState",
};
